import React from 'react';
import styled from '@emotion/styled';
import { spacing } from '@naf/theme';
import { YoutubeEmbed, YoutubeVideo } from '../../../../YoutubeEmbed';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import { BlockContentContext } from '../../../BlockContent.utils';

interface YoutubeEmbedSerializerProps {
  value: YoutubeVideo;
}
export const YoutubeSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: YoutubeEmbedSerializerProps) => (
      <ArticleBlockContentGridCol>
        <YoutubeEmbed embed={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: YoutubeEmbedSerializerProps) => (
    <Wrapper>
      <YoutubeEmbed embed={value} />
    </Wrapper>
  );
};

export const Wrapper = styled.div`
  margin: ${spacing.space8} 0 ${spacing.space24} 0;
`;
